import { render, staticRenderFns } from "./SubscriberDetails.vue?vue&type=template&id=ca9c837a&scoped=true"
import script from "./SubscriberDetails.vue?vue&type=script&lang=js"
export * from "./SubscriberDetails.vue?vue&type=script&lang=js"
import style0 from "./SubscriberDetails.vue?vue&type=style&index=0&id=ca9c837a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9c837a",
  null
  
)

export default component.exports